
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 24 24","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M8 13h10.586l-3.293 3.293 1.414 1.414L22.414 12l-5.707-5.707-1.414 1.414L18.586 11H8v2zm-4 8h9v-2H4V5h9V3H4a2 2 0 00-2 2v14a2 2 0 002 2z"}})])
          )
        }
      }
    